import { memo, lazy, Suspense } from "react"
import type { DbObject } from "@/db/schema"

// S13: Lazy-load the entire TipTap editor — only fetched when a task is
// expanded. Until the chunk arrives, show the cached docHtml as static HTML.
const LazyEditorShell = lazy(() =>
  import("@/features/editor").then((m) => ({ default: m.EditorShell })),
)

interface DetailNotesProps {
  task: DbObject
}

/**
 * Rich text notes editor for task detail.
 *
 * Renders EditorShell (TipTap + Y.Doc via DexieYProvider) bound to the task.
 * The Y.Doc is persisted automatically by y-dexie — no manual save needed.
 */
export const DetailNotes = memo(function DetailNotes({
  task,
}: DetailNotesProps) {
  return (
    <Suspense
      fallback={
        task.docHtml ? (
          <div
            className="ProseMirror min-h-[4rem] px-4 py-2 opacity-60"
            dangerouslySetInnerHTML={{ __html: task.docHtml }}
          />
        ) : (
          <div className="min-h-[4rem]" />
        )
      }
    >
      <LazyEditorShell
        taskId={task.id!}
        className="min-h-[4rem]"
        initialCachedHtml={task.docHtml}
      />
    </Suspense>
  )
})
